import React from 'react';
import { Link } from 'react-router-dom';
import { Linkedin, Mail } from 'lucide-react';

const LOGO_URL = 'https://customer-assets.emergentagent.com/job_biotech-labs-1/artifacts/lbc5xhdz_Biovex%20Technologies%20logo%20design.png';

const footerLinks = [
  { label: 'About', path: '/about' },
  { label: 'Projects', path: '/projects' },
  { label: 'Research', path: '/research' },
  { label: 'Contact', path: '/contact' },
];

const socialLinks = [
  { icon: Linkedin, href: 'https://www.linkedin.com/company/biovex-technologies/', label: 'LinkedIn' },
  { icon: Mail, href: 'mailto:goswamishreyansh83@gmail.com', label: 'Email' },
];

export default function Footer() {
  return (
    <footer className="border-t border-bvx-border bg-bvx-bg">
      <div className="px-6 md:px-12 lg:px-24 py-16">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-12">
          {/* Brand */}
          <div>
            <div className="flex items-center gap-2 mb-4">
              <div className="bg-white/95 rounded-lg p-0.5 h-8 w-8 flex items-center justify-center overflow-hidden">
                <img src={LOGO_URL} alt="Biovex Technologies" className="h-full w-full object-cover object-top" />
              </div>
              <span className="font-outfit font-bold text-white text-base">
                BIOVEX<span className="text-bvx-cyan">.</span>
              </span>
            </div>
            <p className="text-white/50 text-sm font-inter-tight leading-relaxed max-w-xs">
              Engineering the future of human biology. India-based biotech and health-tech innovation.
            </p>
          </div>

          {/* Links */}
          <div>
            <h4 className="font-rajdhani font-semibold uppercase tracking-widest text-white/40 text-xs mb-5">
              Navigation
            </h4>
            <div className="flex flex-col gap-3">
              {footerLinks.map((link) => (
                <Link
                  key={link.path}
                  to={link.path}
                  data-testid={`footer-link-${link.label.toLowerCase()}`}
                  className="text-white/60 hover:text-white text-sm font-inter-tight transition-colors duration-200"
                >
                  {link.label}
                </Link>
              ))}
            </div>
          </div>

          {/* Contact */}
          <div>
            <h4 className="font-rajdhani font-semibold uppercase tracking-widest text-white/40 text-xs mb-5">
              Connect
            </h4>
            <div className="flex gap-3 mb-5">
              {socialLinks.map(({ icon: Icon, href, label }) => (
                <a
                  key={label}
                  href={href}
                  data-testid={`social-${label.toLowerCase()}`}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="w-9 h-9 rounded-lg bg-white/5 border border-white/10 flex items-center justify-center text-white/50 hover:text-bvx-cyan hover:border-bvx-cyan/40 transition-colors duration-200"
                  aria-label={label}
                >
                  <Icon size={15} />
                </a>
              ))}
            </div>
            <p className="text-white/40 text-xs font-inter-tight">goswamishreyansh83@gmail.com</p>
            <p className="text-white/40 text-xs font-inter-tight mt-1">India</p>
          </div>
        </div>

        <div className="mt-12 pt-6 border-t border-bvx-border flex flex-col sm:flex-row items-start sm:items-center justify-between gap-3">
          <p className="text-white/30 text-xs font-inter-tight">
            &copy; {new Date().getFullYear()} Biovex Technologies Ltd. All rights reserved.
          </p>
          <Link
            to="/admin"
            data-testid="footer-admin-link"
            className="text-white/20 hover:text-white/50 text-xs font-inter-tight transition-colors duration-200"
          >
            Admin
          </Link>
        </div>
      </div>
    </footer>
  );
}
